"use client";
import React from "react";
import type { Props } from "@/components/pricing";
import { paddingMap } from "@/components/pricing";
import { getBackgroundStyle } from "@/lib/background";
import { Check, Minus } from "lucide-react";

export default function PricingCompare({ data }: Props) {
  const {
    title,
    subtitle,
    comparison = { enabled: false, headers: [], rows: [] },
    background,
    padding = "xl",
  } = data || {};

  if (
    !comparison.enabled ||
    !comparison.rows?.length ||
    !comparison.headers?.length
  ) {
    return null;
  }

  const bgStyle = getBackgroundStyle(background);

  return (
    <section
      className={`${paddingMap[padding] || "py-20 px-6"}`}
      style={bgStyle}
    >
      <div className="max-w-6xl mx-auto text-center">
        {title && (
          <h2 className="text-4xl font-bold mb-4 text-foreground">{title}</h2>
        )}
        {subtitle && (
          <p className="text-lg text-muted-foreground mb-10">{subtitle}</p>
        )}

        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border-collapse">
            <thead>
              <tr>
                <th className="text-left py-3 px-4 border-b">Features</th>
                {comparison.headers.map((header, i) => (
                  <th
                    key={i}
                    className="py-3 px-4 border-b text-center font-semibold"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparison.rows.map((row, rowIdx) => (
                <tr key={rowIdx} className="border-b">
                  <td className="py-2 px-4 text-left font-medium text-foreground">
                    {row.label}
                  </td>
                  {row.values.map((val, colIdx) => (
                    <td key={colIdx} className="py-2 px-4 text-center">
                      {typeof val === "boolean" ? (
                        val ? (
                          <Check className="w-4 h-4 mx-auto text-green-600" />
                        ) : (
                          <Minus className="w-4 h-4 mx-auto text-muted-foreground" />
                        )
                      ) : (
                        val
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
